# frozen_string_literal: true

module Engine
  module Game
    module G1825
    end
  end
end
